const defaultForm = {
  enabled: false,
  mode: 'INTERVAL',
  amount: '30',
  unit: 'MINUTES',
  time: '09:00',
  weekday: '1',
  cron: '',
}

export const scheduleToForm = (schedules = []) => {
  const schedule = schedules.find((item) => item.active) || schedules[0]
  if (!schedule) return { ...defaultForm }

  const form = { ...defaultForm, enabled: schedule.active !== false }
  if (schedule.scheduleType === 'INTERVAL') {
    const minutes = Number(schedule.frequencyMinutes) || 30
    if (minutes % 1440 === 0) return { ...form, amount: String(minutes / 1440), unit: 'DAYS' }
    if (minutes % 60 === 0) return { ...form, amount: String(minutes / 60), unit: 'HOURS' }
    return { ...form, amount: String(minutes) }
  }

  const cron = String(schedule.cronExpression || '')
  const fields = cron.trim().split(/\s+/)
  if (fields.length === 5) {
    const [minute, hour, day, month, weekday] = fields
    if (/^\d{1,2}$/.test(minute) && /^\d{1,2}$/.test(hour) && Number(minute) < 60 && Number(hour) < 24 && day === '*' && month === '*') {
      const time = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`
      if (weekday === '*') return { ...form, mode: 'DAILY', time }
      if (/^[0-6]$/.test(weekday)) return { ...form, mode: 'WEEKLY', time, weekday }
    }
  }
  return { ...form, mode: 'CRON', cron }
}

export const formToSchedule = (form) => {
  if (form.mode === 'INTERVAL') {
    const amount = Number(form.amount)
    const factor = { MINUTES: 1, HOURS: 60, DAYS: 1440 }[form.unit]
    const minutes = amount * factor
    if (!Number.isInteger(amount) || amount < 1 || !Number.isSafeInteger(minutes) || minutes > 525600) {
      throw new Error('Indica una frecuencia valida entre 1 minuto y 365 dias.')
    }
    return { scheduleType: 'INTERVAL', frequencyMinutes: minutes, active: form.enabled }
  }

  if (form.mode === 'DAILY' || form.mode === 'WEEKLY') {
    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(form.time)) throw new Error('Indica una hora valida.')
    const [hour, minute] = form.time.split(':').map(Number)
    const weekday = form.mode === 'WEEKLY' ? form.weekday : '*'
    return { scheduleType: 'CRON', cronExpression: `${minute} ${hour} * * ${weekday}`, active: form.enabled }
  }

  if (!form.cron.trim()) throw new Error('Indica una expresion cron.')
  return { scheduleType: 'CRON', cronExpression: form.cron.trim(), active: form.enabled }
}
